import { EmailInbox } from "Components/Private/Email";

export const Email = ({ gid, is360View }) => {
  return (
    <div className="applicant-status-body email-tab bg-white">
      <EmailInbox gid={gid} is360View={is360View} />
    </div>
  );
};
